import {observable, action} from 'mobx';
import axiosInstance from '~/utils/axiosInstance';
import Asset from './models/Asset';
import uris from '~/uris';
import Pagination from './Pagination';

class AssetStore extends Pagination {
  @observable assets = [];

  @observable isLoading = false;

  @action resetLoading() {
    this.isLoading = false;
  }

  @action.bound
  setAssets(data) {
    this.assets = data;
  }

  @action.bound
  getAssetList(body = {}) {
    this.isLoading = true;
    return axiosInstance
      .post(uris.getAssetList(), {
        ...body
      })
      .then((data) => {
        this.setAssets(data.assets.map(json => this.updateAssetFromServer(json)));
        this.resetLoading();
        this.setPagination(data.pagination);
      })
      .catch(() => {
        this.resetLoading();
      });
  }

  @action.bound
  getAssetListWithAddition(body = {}) {
    let data = {
      ...this.paginationRequestBody
    };

    if (body.forceFresh) {
      data = {
        ...this.initPaginationRequestBody
      };
    }

    return this.getAssetList({
      ...data,
      ...body
    });
  }

  @action.bound
  changePagination(pagination) {
    super.changePagination(pagination);
    this.getAssetListWithAddition();
  }

  @action.bound
  updateAssetFromServer(json) {
    let asset = this.assets.find(({id}) => id === json.id);
    if (!asset) {
      asset = new Asset(this, json.id);
    }
    asset.updateFromJson(json);
    return asset;
  }

  @action.bound
  syncAssetTree() {
    return axiosInstance.post(uris.syncAssetTree());
  }
}

export default new AssetStore();
